import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { RefType } from './reftype.enum';
import { Group } from '../entities/schema/group.entity';
import { GroupTreeAssigment } from '../entities/schema/grouptreeassigment.entity';
import { GroupTree } from '../entities/schema/grouptree.entity';
import { Status } from '../entities/settings/status.entity';
import { StatusType } from '../entities/settings/statustype.entity';
//#endregion

@Injectable()
export class GroupTreeAssigmentService extends ODataEntityService<GroupTreeAssigment> {
  constructor(protected client: ODataClient) {
    super(client, 'GroupTreeAssigment', 'entities.schema.GroupTreeAssigment');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  public group(entity: EntityKey<GroupTreeAssigment>): ODataNavigationPropertyResource<Group> {
    return this.entity(entity).navigationProperty<Group>('group');
  }
  public groupTree(entity: EntityKey<GroupTreeAssigment>): ODataNavigationPropertyResource<GroupTree> {
    return this.entity(entity).navigationProperty<GroupTree>('groupTree');
  }
  public status(entity: EntityKey<GroupTreeAssigment>): ODataNavigationPropertyResource<Status> {
    return this.entity(entity).navigationProperty<Status>('status');
  }
  public statusType(entity: EntityKey<GroupTreeAssigment>): ODataNavigationPropertyResource<StatusType> {
    return this.entity(entity).navigationProperty<StatusType>('statusType');
  }
  //#endregion
}
